<template>
  <div class="MainMenu lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="MainMenu-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="MainMenu-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
        <div class="MainMenu-button lxn-margin-auto lxn-w100">
          <CustomButton @click="$router.push('/instructions/')" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
            {{$store.getters.language.texts.HomeInstruction_button1}}
          </CustomButton>
        </div>
        <div class="MainMenu-button lxn-margin-auto lxn-w100">
          <CustomButton @click="$router.push('/scenarios/')" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
            {{$store.getters.language.texts.HomeInstruction_button2}}
          </CustomButton>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomButton from "@/components/CustomButton";
import WrapperSvgTitleText from "@/components/addNewDevice/WrapperSvgTitleText";

export default {
  name: 'HomeScenarios',
  components: {
    CustomCurve,
    CustomButton,
    TopNav,
    WrapperSvgTitleText,
    ButtonIcon
  },
}
</script>

<style>
.MainMenu-topCurve-wrapper {
  height: 200px;
}
.MainMenu-main-wrapper {
  width: calc(100% - 36px);
  margin-top: -150px;
  background-color: #ffffff;
  padding: 20px;
  z-index: 9;
}
.MainMenu-button {
  margin-bottom: 14px;
}
.MainMenu-button:first-child {
  margin-top: 14px;
}
</style>